import { render, staticRenderFns } from "./TrainingsList.vue?vue&type=template&id=de84a2ea&"
import script from "./TrainingsList.vue?vue&type=script&lang=js&"
export * from "./TrainingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports